export const MANAGED_COLLECTION_SHOW_TABS = [
  'general',
  'publications',
  'collection',
  'search',
] as const;

export type ManagedCollectionShowTab =
  (typeof MANAGED_COLLECTION_SHOW_TABS)[number];

export const MANAGED_COLLECTION_DEFAULT_TAB: ManagedCollectionShowTab =
  'general';
